










import { Component, Prop, Vue } from 'vue-property-decorator'
import { Circuit } from '@/interfaces'

@Component
export default class CircuitList extends Vue {
  @Prop({ default: [] }) circuits!: Circuit[]

  navigateToCircuit (circuit: Circuit) {
    this.$router.push({ name: 'circuit-info', params: { circuitId: circuit.id } })
  }
}
